import { render, staticRenderFns } from "./WasteDistribution.vue?vue&type=template&id=d8c32bee&scoped=true&"
import script from "./WasteDistribution.vue?vue&type=script&lang=js&"
export * from "./WasteDistribution.vue?vue&type=script&lang=js&"
import style0 from "./WasteDistribution.vue?vue&type=style&index=0&id=d8c32bee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c32bee",
  null
  
)

export default component.exports